import { css } from '@emotion/react'
import { XApp } from '@livechat/design-system-icons'
import { Icon } from '@livechat/design-system-react-components'

import DribbbleIcon from '@/assets/icons/dribbble.inline.svg'
import FacebookIcon from '@/assets/icons/facebook.inline.svg'
import GithubIcon from '@/assets/icons/github.inline.svg'
import InstagramIcon from '@/assets/icons/instagram.inline.svg'
import LinkedinIcon from '@/assets/icons/linkedin.inline.svg'
import ProducthuntIcon from '@/assets/icons/producthunt.inline.svg'
import YoutubeIcon from '@/assets/icons/youtube.inline.svg'

const iconsCss = (theme) => css`
  max-width: 352px;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  a {
    color: ${theme.colors.black};
    margin: 7px;
  }

  > div {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
`

const Icons = () => {
  return (
    <div css={iconsCss}>
      <div>
        <a href={process.env.GATSBY_PRODUCT_TWITTER}>
          <Icon source={XApp} size="large" />
        </a>
        <a href={process.env.GATSBY_PRODUCT_LINKEDIN}>
          <LinkedinIcon />
        </a>
        <a href={process.env.GATSBY_PRODUCT_FACEBOOK}>
          <FacebookIcon />
        </a>
        <a href={process.env.GATSBY_PRODUCT_YOUTUBE}>
          <YoutubeIcon />
        </a>
      </div>
      <div>
        <a href={process.env.GATSBY_PRODUCT_INSTAGRAM}>
          <InstagramIcon />
        </a>
        <a href={process.env.GATSBY_PRODUCT_PRODUCTHUNT}>
          <ProducthuntIcon />
        </a>
        <a href={process.env.GATSBY_PRODUCT_DRIBBBLE}>
          <DribbbleIcon />
        </a>
        <a href={process.env.GATSBY_PRODUCT_GITHUB}>
          <GithubIcon />
        </a>
      </div>
    </div>
  )
}

export default Icons
